/** @jsx jsx */
import React from "react";
import { jsx, css } from "@emotion/core";
interface Props extends Omit<React.SVGProps<SVGSVGElement>, "css"> {
  weight?: "thin" | "normal";
}
export const IconTelescope3 = React.forwardRef<SVGSVGElement, Props>(
  (
    { fill = "none", stroke = "currentColor", weight = "normal", ...props },
    ref,
  ) => (
    <svg
      viewBox="0 0 24 24"
      ref={ref}
      css={css`
        * {
          vector-effect: non-scaling-stroke;
        }
        overflow: visible;
        height: 24px;
      `}
      {...props}
    >
      <g
        fill={fill}
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={weight === "normal" ? 1.5 : 1}
      >
        <path d="M20.828 14.357c-3.222 3.222-8.446 3.222-11.667-.001s-3.222-8.445 0-11.667l11.667 11.668zM21.359 5.341a2.25 2.25 0 1 1-3.184-3.178A2.25 2.25 0 0 1 21.36 5.34l-.001.001zM18.177 5.341l-3.182 3.182M3.25 22.522l4.243-4.242a1.5 1.5 0 0 1 2.121 0l4.243 4.242" />
      </g>
    </svg>
  ),
);
